import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Public Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Departments from "./pages/Departments";
import DepartmentDetail from "./pages/DepartmentDetail";
import Programmes from "./pages/Programmes";
import ProgrammeDetail from "./pages/ProgrammeDetail";
import ShortCourses from "./pages/ShortCourses";
import StartupsPage from "./pages/StartupsPage";
import StartupPage from "./pages/StartupPage";
import Admissions from "./pages/Admissions";
import Apply from "./pages/Apply";
import Research from "./pages/Research";
import News from "./pages/News";
import FashionShowEvent from "./pages/FashionShowEvent";
import FootballEvent from "./pages/events/FootballEvent";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminApplications from "./pages/admin/AdminApplications";
import AdminApplicationDetail from "./pages/admin/AdminApplicationDetail";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-[#1e3a5f] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/departments" element={<Departments />} />
      <Route path="/departments/:id" element={<DepartmentDetail />} />
      <Route path="/programmes" element={<Programmes />} />
      <Route path="/programmes/:id" element={<ProgrammeDetail />} />
      <Route path="/short-courses" element={<ShortCourses />} />
      <Route path="/startups" element={<StartupsPage />} />
      <Route path="/startups/:id" element={<StartupPage />} />
      <Route path="/admissions" element={<Admissions />} />
      <Route path="/apply" element={<Apply />} />
      <Route path="/research" element={<Research />} />
      <Route path="/news" element={<News />} />
      <Route path="/news/bit-fashion-show-and-modeling-event" element={<FashionShowEvent />} />
      <Route path="/news/bit-football-match-campus-sports-event" element={<FootballEvent />} />
      <Route path="/contact" element={<Contact />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/applications"
        element={
          <ProtectedRoute>
            <AdminApplications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/applications/:id"
        element={
          <ProtectedRoute>
            <AdminApplicationDetail />
          </ProtectedRoute>
        }
      />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
